// Sanitizador GENÉRICO de payloads de error para incluir contexto en eventos
// `*Failed` sin meter PII en Mixpanel. Réplica del de propi-web-nextjs
// (`src/lib/analytics/errorPayload.ts`). Se usa para `response_payload` — el
// response NUNCA trae tarjeta, así que el genérico alcanza. El `request_payload`
// (que sí trae tarjeta) lo maneja el sanitizer TIPADO (paymentTrackingSanitizer).
//
// Reglas:
//   - Allowlist por keys: las keys de PII_KEYS se reemplazan por "[REDACTED]".
//   - Regex de defensa: emails y números largos en strings se censuran.
//   - Truncado a MAX_LEN para no explotar volumen en Mixpanel.

const PII_KEYS = new Set([
  'email',
  'phone',
  'first_name',
  'last_name',
  'name',
  'token',
  'password',
  'area_code',
  'document',
  'document_number',
  'code',
  'otp',
  'request_id',
  'access_token',
  'refresh_token',
  'id_token',
])

const MAX_LEN = 500

// Regex defensivo — strippea emails y secuencias de 7+ dígitos (teléfonos, docs)
// dentro de strings de valor. No es perfecto pero reduce el blast radius.
const PII_PATTERNS: Array<[RegExp, string]> = [
  [/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email]'],
  [/\b\d{7,}\b/g, '[number]'],
]

const scrubString = (s: string): string => {
  let out = s
  for (const [pattern, replacement] of PII_PATTERNS) {
    out = out.replace(pattern, replacement)
  }
  return out
}

/**
 * Serializa un payload (response data, error object) strippeando PII y truncando
 * para uso seguro como prop de evento `*Failed` en Mixpanel.
 *
 * @param obj cualquier valor — null/undefined retorna undefined
 * @returns string JSON sanitizado y truncado, o undefined
 */
export const sanitizeErrorPayload = (obj: unknown): string | undefined => {
  if (obj == null) return undefined
  try {
    const json = JSON.stringify(obj, (key, value) => {
      if (PII_KEYS.has(key)) return '[REDACTED]'
      if (typeof value === 'string') return scrubString(value)
      return value
    })
    if (json === undefined) return undefined
    return json.length > MAX_LEN ? json.slice(0, MAX_LEN) + '…' : json
  } catch {
    return '[unserializable]'
  }
}
